<div class="home-page-preview"
     [class.device-desktop]="deviceType === 'desktop'"
     [class.device-tablet]="deviceType === 'tablet'"
     [class.device-mobile]="deviceType === 'mobile'"
     [class.page-loaded]="isPageLoaded">
  
   <!-- Hero Section (contains header inside) -->
   <!-- Layouts 1-3: Regular layouts with header inside hero -->
   <div class="website-element hero-element" 
        *ngIf="isElementVisible('hero') && (getHeroLayout() === 'layout_1' || getHeroLayout() === 'layout_2' || getHeroLayout() === 'layout_3')"
        [class.selected]="getElementByIndex(1)?.selected"
        [class.layout-1]="getHeroLayout() === 'layout_1'"
        [class.layout-2]="getHeroLayout() === 'layout_2'"
        [class.layout-3]="getHeroLayout() === 'layout_3'"
        [style.background-color]="getHeroBackgroundColor()">
     
     <!-- Header Section inside Hero -->
     <div class="hero-header-wrapper" (click)="onHeaderClick()">
   <app-champs-page-header
     *ngIf="isElementVisible('header')"
     [logo]="getHeaderLogo()"
     [navigation]="getHeaderNavigation()"
     [ctaButton]="getHeaderCTAButton()"
     [visible]="true"
     [clickable]="true"
     [selected]="isHeaderSelected()"
     [headingColor]="headingColor"
     [headingFont]="headingFont"
     [backgroundColor]="getHeaderBackgroundColor()"
     [deviceType]="deviceType"
     [inHero]="true"
     (headerClick)="onHeaderClick()"
     (navigationClick)="onNavigationClick($event)">
   </app-champs-page-header>
     </div>

     <!-- Hero Content -->
     <div class="hero-content-wrapper" (click)="onElementClick(getElementByIndex(1))">
     <!-- Layout 1: Text Left, Image Right -->
     <app-hero-layout-1-preview
       *ngIf="getHeroLayout() === 'layout_1'"
       [data]="getHeroLayoutData()"
       [headingColor]="getHeadingColor()"
       [paragraphColor]="getParagraphColor()"
       [headingFont]="getHeadingFont()"
       [bodyFont]="getBodyFont()"
       [primaryColor]="getPrimaryColor()"
       [titleStyles]="getTitleStyles(getElementByIndex(1))"
       (buttonClick)="onButtonClick($event.link, $event.event)">
     </app-hero-layout-1-preview>

     <!-- Layout 2: Image Top, Text Centered -->
     <app-hero-layout-2-preview
       *ngIf="getHeroLayout() === 'layout_2'"
       [data]="getHeroLayoutData()"
       [headingColor]="getHeadingColor()"
       [paragraphColor]="getParagraphColor()"
       [headingFont]="getHeadingFont()"
       [bodyFont]="getBodyFont()"
       [primaryColor]="getPrimaryColor()"
       [titleStyles]="getTitleStyles(getElementByIndex(1))"
       (buttonClick)="onButtonClick($event.link, $event.event)">
     </app-hero-layout-2-preview>

     <!-- Layout 3: Image Left, Text Right -->
     <app-hero-layout-3-preview
       *ngIf="getHeroLayout() === 'layout_3'"
       [data]="getHeroLayoutData()"
       [headingColor]="getHeadingColor()"
       [paragraphColor]="getParagraphColor()"
       [headingFont]="getHeadingFont()"
       [bodyFont]="getBodyFont()"
       [primaryColor]="getPrimaryColor()"
       [titleStyles]="getTitleStyles(getElementByIndex(1))"
       (buttonClick)="onButtonClick($event.link, $event.event)">
     </app-hero-layout-3-preview>
   </div>
   </div>

   <!-- Layouts 4-6: Background image layouts (full hero element, header separate) -->
   <!-- Header Section (separate for layouts 4-6) -->
   <app-champs-page-header
     *ngIf="isElementVisible('hero') && (getHeroLayout() === 'layout_4' || getHeroLayout() === 'layout_5' || getHeroLayout() === 'layout_6') && isElementVisible('header')"
     [logo]="getHeaderLogo()"
     [navigation]="getHeaderNavigation()"
     [ctaButton]="getHeaderCTAButton()"
     [visible]="true"
     [clickable]="true"
     [selected]="isHeaderSelected()"
     [headingColor]="headingColor"
     [headingFont]="headingFont"
     [backgroundColor]="getHeaderBackgroundColor()"
     [deviceType]="deviceType"
     [inHero]="true"
     (headerClick)="onHeaderClick()"
     (navigationClick)="onNavigationClick($event)">
   </app-champs-page-header>

   <!-- Layout 4: Text at Top with Background Image -->
   <div class="website-element hero-element" 
        *ngIf="isElementVisible('hero') && getHeroLayout() === 'layout_4'"
        [class.selected]="getElementByIndex(1)?.selected"
        [class.layout-4]="true"
        (click)="onElementClick(getElementByIndex(1))">
     <app-hero-layout-4-preview
       [data]="getHeroLayoutData()"
       [headingColor]="getHeadingColor()"
       [paragraphColor]="getParagraphColor()"
       [headingFont]="getHeadingFont()"
       [bodyFont]="getBodyFont()"
       [primaryColor]="getPrimaryColor()"
       [titleStyles]="getTitleStyles(getElementByIndex(1))"
       (buttonClick)="onButtonClick($event.link, $event.event)">
     </app-hero-layout-4-preview>
   </div>

   <!-- Layout 5: Text Vertically Centered with Background Image -->
   <div class="website-element hero-element" 
        *ngIf="isElementVisible('hero') && getHeroLayout() === 'layout_5'"
        [class.selected]="getElementByIndex(1)?.selected"
        [class.layout-5]="true"
        (click)="onElementClick(getElementByIndex(1))">
     <app-hero-layout-5-preview
       [data]="getHeroLayoutData()"
       [headingColor]="getHeadingColor()"
       [paragraphColor]="getParagraphColor()"
       [headingFont]="getHeadingFont()"
       [bodyFont]="getBodyFont()"
       [primaryColor]="getPrimaryColor()"
       [titleStyles]="getTitleStyles(getElementByIndex(1))"
       (buttonClick)="onButtonClick($event.link, $event.event)">
     </app-hero-layout-5-preview>
   </div>

   <!-- Layout 6: Text Vertically Bottom with Background Image -->
   <div class="website-element hero-element" 
        *ngIf="isElementVisible('hero') && getHeroLayout() === 'layout_6'"
        [class.selected]="getElementByIndex(1)?.selected"
        [class.layout-6]="true"
        (click)="onElementClick(getElementByIndex(1))">
     <app-hero-layout-6-preview
       [data]="getHeroLayoutData()"
       [headingColor]="getHeadingColor()"
       [paragraphColor]="getParagraphColor()"
       [headingFont]="getHeadingFont()"
       [bodyFont]="getBodyFont()"
       [primaryColor]="getPrimaryColor()"
       [titleStyles]="getTitleStyles(getElementByIndex(1))"
       (buttonClick)="onButtonClick($event.link, $event.event)">
     </app-hero-layout-6-preview>
   </div>

   <!-- Layout 7: Modern Template Style -->
   <div class="website-element hero-element" 
        *ngIf="isElementVisible('hero') && getHeroLayout() === 'layout_7'"
        [class.selected]="getElementByIndex(1)?.selected"
        [class.layout-7]="true"
        [style.background-color]="getHeroBackgroundColor()">
     
     <!-- Header Section inside Hero -->
     <div class="hero-header-wrapper" (click)="onHeaderClick()">
       <app-champs-page-header
         *ngIf="isElementVisible('header')"
         [logo]="getHeaderLogo()"
         [navigation]="getHeaderNavigation()"
         [ctaButton]="getHeaderCTAButton()"
         [visible]="true"
         [clickable]="true"
         [selected]="isHeaderSelected()"
         [headingColor]="headingColor"
         [headingFont]="headingFont"
         [backgroundColor]="getHeaderBackgroundColor()"
         [deviceType]="deviceType"
         [inHero]="true"
         (headerClick)="onHeaderClick()"
         (navigationClick)="onNavigationClick($event)">
       </app-champs-page-header>
     </div>

     <!-- Hero Content -->
     <div class="hero-content-wrapper" (click)="onElementClick(getElementByIndex(1))">
       <app-hero-layout-7-preview
         [data]="getHeroLayoutData()"
         [headingColor]="getHeadingColor()"
         [paragraphColor]="getParagraphColor()"
         [headingFont]="getHeadingFont()"
         [bodyFont]="getBodyFont()"
         [primaryColor]="getPrimaryColor()"
         [titleStyles]="getTitleStyles(getElementByIndex(1))"
         (buttonClick)="onButtonClick($event.link, $event.event)">
       </app-hero-layout-7-preview>
     </div>
   </div>

  <!-- Render all elements in order (preserving JSON order) -->
  <ng-container *ngFor="let element of elements; let i = index; trackBy: trackByIndex">
    <!-- Info Sections (info_section, info_section_1, etc.) - rendered in their JSON order -->
  <div class="website-element section-element" 
         *ngIf="isInfoSectionElement(element) && isInfoSectionVisible(element) && element?.content"
         [class.selected]="element?.selected"
         [class.layout-1]="getInfoSectionLayout(element) === 'layout_1'"
         [class.layout-2]="getInfoSectionLayout(element) === 'layout_2'"
         [class.layout-3]="getInfoSectionLayout(element) === 'layout_3'"
         [class.layout-4]="getInfoSectionLayout(element) === 'layout_4'"
         [class.layout-5]="getInfoSectionLayout(element) === 'layout_5'"
         [style.background-color]="element?.content?.backgroundColor"
         (click)="onElementClick(element)">
    <!-- Layout 1: Title+Description, Then Full-Width Image Below -->
    <app-info-layout-1-preview
      *ngIf="getInfoSectionLayout(element) === 'layout_1'"
      [data]="getInfoLayoutData(element)"
      [headingColor]="getHeadingColor()"
      [paragraphColor]="getParagraphColor()"
      [headingFont]="getHeadingFont()"
      [bodyFont]="getBodyFont()"
      [primaryColor]="getPrimaryColor()"
      [titleStyles]="getTitleStyles(element)"
      (buttonClick)="onButtonClick($event.link, $event.event)">
    </app-info-layout-1-preview>

    <!-- Layout 2: Text Left, Image Right -->
    <app-info-layout-2-preview
      *ngIf="getInfoSectionLayout(element) === 'layout_2'"
      [data]="getInfoLayoutData(element)"
      [headingColor]="getHeadingColor()"
      [paragraphColor]="getParagraphColor()"
      [headingFont]="getHeadingFont()"
      [bodyFont]="getBodyFont()"
      [primaryColor]="getPrimaryColor()"
      [titleStyles]="getTitleStyles(element)"
      (buttonClick)="onButtonClick($event.link, $event.event)">
    </app-info-layout-2-preview>

    <!-- Layout 3: Title Left, Description Right, Image Bottom -->
    <app-info-layout-3-preview
      *ngIf="getInfoSectionLayout(element) === 'layout_3'"
      [data]="getInfoLayoutData(element)"
      [headingColor]="getHeadingColor()"
      [paragraphColor]="getParagraphColor()"
      [headingFont]="getHeadingFont()"
      [bodyFont]="getBodyFont()"
      [primaryColor]="getPrimaryColor()"
      [titleStyles]="getTitleStyles(element)"
      (buttonClick)="onButtonClick($event.link, $event.event)">
    </app-info-layout-3-preview>

    <!-- Layout 4: Description Left, Title Right, Image Bottom (Inverse of Layout 3) -->
    <app-info-layout-4-preview
      *ngIf="getInfoSectionLayout(element) === 'layout_4'"
      [data]="getInfoLayoutData(element)"
      [headingColor]="getHeadingColor()"
      [paragraphColor]="getParagraphColor()"
      [headingFont]="getHeadingFont()"
      [bodyFont]="getBodyFont()"
      [primaryColor]="getPrimaryColor()"
      [titleStyles]="getTitleStyles(element)"
      (buttonClick)="onButtonClick($event.link, $event.event)">
    </app-info-layout-4-preview>

    <!-- Layout 5: Grime Fighters Layout - Title, Description, Image Row, Large Title -->
    <app-info-layout-5-preview
      *ngIf="getInfoSectionLayout(element) === 'layout_5'"
      [data]="getInfoLayoutData(element)"
      [headingColor]="getHeadingColor()"
      [paragraphColor]="getParagraphColor()"
      [headingFont]="getHeadingFont()"
      [bodyFont]="getBodyFont()"
      [primaryColor]="getPrimaryColor()"
      [titleStyles]="getTitleStyles(element)"
      (buttonClick)="onButtonClick($event.link, $event.event)">
    </app-info-layout-5-preview>
  </div>

  <!-- Testimonials Section -->
  <div class="website-element testimonials-element" 
         *ngIf="element.type === 'testimonials' && isElementVisible('testimonials') && element?.content"
         [class.selected]="element?.selected"
         [style.background-color]="element?.content?.backgroundColor"
         (click)="onElementClick(element)">
    <div class="testimonials-container">
      <div class="testimonials-header">
          <h2 class="testimonials-title"
              [style.color]="getHeadingColor()"
              [style.font-family]="getHeadingFont()"
              [ngStyle]="getTitleStyles(element)">{{ getTitleSafe(element) }}</h2>
        <p class="testimonials-subtitle"
           [style.color]="getParagraphColor()"
           [style.font-family]="getBodyFont()">
            {{ element?.content?.description }}
        </p>
      </div>
      
      <!-- Carousel Wrapper -->
      <div class="testimonials-carousel-wrapper"
           (touchstart)="onTouchStart($event)"
           (touchend)="onTouchEnd($event)">
        <!-- Carousel Track -->
        <div class="testimonials-carousel-track"
             [style.transform]="'translateX(-' + (currentTestimonialSlide * 100) + '%)'">
          <div class="testimonials-slide"
               *ngFor="let slideIndex of getTestimonialPaginationDots(); trackBy: trackByIndex">
            <div class="testimonials-grid">
              <div class="testimonial-card" 
                   [style.background-color]="element?.content?.cardColor"
                   *ngFor="let testimonial of getTestimonialsForSlide(slideIndex); trackBy: trackByTestimonialId">
                <!-- Client Details -->
                <div class="client-details">
                  <div class="author-avatar">
                    <img *ngIf="testimonial.author?.avatar" 
                         [src]="testimonial.author.avatar" 
                         [alt]="testimonial.author?.name" 
                         class="avatar-image">
                    <div *ngIf="!testimonial.author?.avatar" class="avatar-placeholder">
                      {{ (testimonial.author?.name || 'U').charAt(0).toUpperCase() }}
                    </div>
                  </div>
                  <div class="person-details">
                    <span class="author-name">{{ testimonial.author?.name }}</span>
                  </div>
                </div>
                <!-- Testimonial Text -->
                <p class="testimonial-text">
                  <span [style.color]="getParagraphColor()"
                        [style.font-family]="getBodyFont()">"{{ testimonial.text }}"</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Pagination Dots -->
      <div class="testimonials-pagination"
           *ngIf="getTotalTestimonialSlides() > 1">
        <div class="pagination-dot" 
             *ngFor="let dot of getTestimonialPaginationDots(); let i = index; trackBy: trackByIndex"
             [class.active]="i === currentTestimonialSlide"
             (click)="goToTestimonialSlide(i); $event.stopPropagation()"
             [attr.aria-label]="'Go to slide ' + (i + 1)"></div>
      </div>
    </div>
  </div>

  <!-- Booking Section -->
  <div class="website-element booking-element" 
         *ngIf="element.type === 'booking' && isElementVisible('booking') && element?.content"
         [class.selected]="element?.selected"
         [style.background-color]="element?.content?.backgroundColor"
         (click)="onElementClick(element)">
    <div class="booking-container">
      <!-- Layout 1: Default Light Theme (with external header) -->
      <div *ngIf="getBookingLayout(element) === 'layout_1'">
        <div class="booking-header">
          <h2 class="booking-title"
              [style.color]="getHeadingColor()"
              [style.font-family]="getHeadingFont()"
              [ngStyle]="getTitleStyles(element)">{{ getTitleSafe(element) }}</h2>
        <p class="booking-subtitle"
             [style.color]="getParagraphColor()"
             [style.font-family]="getBodyFont()">
            {{ element?.content?.description }}
          </p>
        </div>
        <app-booking-layout-1-preview
          [data]="getBookingLayoutData(element)"
          [headingColor]="getHeadingColor()"
          [paragraphColor]="getParagraphColor()"
          [headingFont]="getHeadingFont()"
          [bodyFont]="getBodyFont()"
          [primaryColor]="getPrimaryColor()"
          [formData]="getBookingFormData(element)"
          (formSubmit)="onBookingLayoutSubmit(element, $event.formData, $event.event)"
          (fieldChange)="onBookingLayoutFieldChange(element, $event.field, $event.value)"
          (dateTimeChange)="onBookingLayoutDateTimeChange(element, $event.field, $event.dateTime)">
        </app-booking-layout-1-preview>
      </div>
      
      <!-- Layout 2: Dark Theme (header included in layout) -->
      <app-booking-layout-2-preview
        *ngIf="getBookingLayout(element) === 'layout_2'"
        [data]="getBookingLayoutData(element)"
        [headingColor]="getHeadingColor()"
        [paragraphColor]="getParagraphColor()"
        [headingFont]="getHeadingFont()"
        [bodyFont]="getBodyFont()"
        [primaryColor]="getPrimaryColor()"
        [formData]="getBookingFormData(element)"
        (formSubmit)="onBookingLayoutSubmit(element, $event.formData, $event.event)"
        (fieldChange)="onBookingLayoutFieldChange(element, $event.field, $event.value)"
        (dateTimeChange)="onBookingLayoutDateTimeChange(element, $event.field, $event.dateTime)">
      </app-booking-layout-2-preview>
    </div>
  </div>

  <!-- Contact Section -->
  <div class="website-element contact-element" 
         *ngIf="element.type === 'contact' && isElementVisible('contact') && element?.content"
         [class.selected]="element?.selected"
         [style.background-color]="element?.content?.backgroundColor"
         (click)="onElementClick(element)">
    <div class="contact-container">
      <!-- Layout 1: Minimal Style -->
      <app-contact-layout-1-preview
        *ngIf="getContactLayout(element) === 'layout_1'"
        [data]="getContactLayoutData(element)"
        [headingColor]="getHeadingColor()"
        [paragraphColor]="getParagraphColor()"
        [headingFont]="getHeadingFont()"
        [bodyFont]="getBodyFont()"
        [primaryColor]="getPrimaryColor()"
        [titleStyles]="getTitleStyles(element)">
      </app-contact-layout-1-preview>

      <!-- Layout 2: Dark Style -->
      <app-contact-layout-2-preview
        *ngIf="getContactLayout(element) === 'layout_2'"
        [data]="getContactLayoutData(element)"
        [headingColor]="getHeadingColor()"
        [paragraphColor]="getParagraphColor()"
        [headingFont]="getHeadingFont()"
        [bodyFont]="getBodyFont()"
        [primaryColor]="getPrimaryColor()"
        [titleStyles]="getTitleStyles(element)">
      </app-contact-layout-2-preview>
    </div>
  </div>
  </ng-container>

  <!-- Footer -->
  <div class="website-element footer-element" 
       *ngIf="isSectionVisible('footer')"
       [class.selected]="getFooterElement()?.selected"
       (click)="onFooterClick($event)">
    <app-champs-page-footer
      [quickLinks]="getFooterQuickLinks()"
      (quickLinkClick)="onNavigationClick($event)"
      [quickLinksTitle]="getFooterQuickLinksTitle()"
      [socialLinks]="getFooterSocialLinks()"
      [socialLinksTitle]="getFooterSocialLinksTitle()"
      [copyright]="getFooterCopyright()"
      [logo]="getFooterLogo()"
      [backgroundColor]="getFooterBackgroundColor()"
      [deviceType]="deviceType">
    </app-champs-page-footer>
  </div>
</div>

